import dayjs from 'dayjs'

/**
 * @desc  格式化时间
 * @param {(Object|string|number)} time
 * @param {string} format
 * @returns {string | null}
 */
export function formatDateTime(time = undefined, format = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs(time).format(format)
}

export function formatDate(date = undefined, format = 'YYYY-MM-DD') {
  return formatDateTime(date, format)
}

export function compareversions(version1, version2) {
  // 处理空版本号情况
  if (!version1 && !version2) return 0;
  if (!version1) return -1;
  if (!version2) return 1;
  
  // 清理版本号（移除空格，转换为大写）
  const cleanVersion1 = version1.trim().toUpperCase();
  const cleanVersion2 = version2.trim().toUpperCase();
  
  // 提取版本号的核心部分，处理十六进制结尾
  function processVersion(version) {
    // 检查版本号末尾是否有十六进制部分（最后1-2位包含A-F）
    let hexPart = null;
    let numericPart = version;
    
    // 检查最后一位是否是十六进制字符
    const lastChar = version.slice(-1);
    if (/^[A-F]$/.test(lastChar)) {
      // 无论倒数第二位是什么，都将最后两位作为一个整体处理
      // 这样可以处理如1B、2A这样的十六进制结尾
      hexPart = version.slice(-2);
      numericPart = version.slice(0, -2);
    }
    
    if (hexPart) {
      // 处理末尾有十六进制的情况
      // 将十六进制部分转换为十进制
      const hexValue = parseInt(hexPart, 16);
      // 确保十六进制部分占两位
      const hexValueStr = hexValue.toString().padStart(2, '0');
      // 组合数字部分和转换后的十六进制值
      const combinedValue = parseInt(numericPart + hexValueStr);
      return {
        value: combinedValue,
        length: numericPart.length + 2
      };
    } else {
      // 处理纯数字版本号
      const numberMatches = version.match(/\d+/g);
      if (numberMatches) {
        // 对于电机固件版本号，特殊处理格式为Gxxxxxx的情况
        if (version.startsWith('G') && numberMatches.length === 2 && 
            numberMatches[0].length === 3 && numberMatches[1].length <= 2) {
          // 合并前3位和后2-3位数字
          return {
            value: parseInt(numberMatches[0] + numberMatches[1]),
            length: numberMatches[0].length + numberMatches[1].length
          };
        } else if (numberMatches.length === 1) {
          // 单个数字部分的情况
          return {
            value: parseInt(numberMatches[0]),
            length: numberMatches[0].length
          };
        } else {
          // 多个数字部分的情况，组合成一个值
          const combinedValue = parseInt(numberMatches.join(''));
          const combinedLength = numberMatches.join('').length;
          return {
            value: combinedValue,
            length: combinedLength
          };
        }
      } else {
        // 如果没有找到数字，返回0
        return { value: 0, length: 0 };
      }
    }
  }
  
  const processed1 = processVersion(cleanVersion1);
  const processed2 = processVersion(cleanVersion2);
  
  // 比较处理后的值
  if (processed1.value > processed2.value) {
    return 1;
  } else if (processed1.value < processed2.value) {
    return -1;
  } else {
    // 如果值相同，比较长度
    if (processed1.length > processed2.length) {
      return 1;
    } else if (processed1.length < processed2.length) {
      return -1;
    } else {
      // 所有都相同
      return 0;
    }
  }
}